import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthServiceApi } from 'src/app/services/services/auth.service';
import { UsersService } from 'src/app/services/users.service';
import { matchOtherValidator } from 'src/app/util/auth/match-other.directive';
import { setForcePasswordChangeFlag } from 'src/app/util/auth/helpers';
import { SharedService } from '../shared_service';
import { DomainConfigComponent } from '../domain-config.component';
import { brand } from '@app/branding/brand';

@Component({
    selector: 'app-force-change-password',
    templateUrl: './force-change-password.component.html',
    styleUrls: ['./force-change-password.component.scss'],
    standalone: false
})
export class ForceChangePasswordComponent implements OnInit {
    changePasswordForm: FormGroup;
    errorMessage = '';
    successMessage = '';
    submitting = false;
    showCurrentPassword = false;
    showPassword = false;
    showConfirmPassword = false;
    readonly brandName = brand.name;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private authApi: AuthServiceApi,
        private usersService: UsersService,
        private sharedService: SharedService,
        private domainConfigComponent: DomainConfigComponent
    ) {
        this.changePasswordForm = this.fb.group({
            currentpassword: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(8)]],
            confirmpassword: ['', [Validators.required, matchOtherValidator('password')]]
        });
    }

    ngOnInit() {
        this.usersService.getDataUser().subscribe({
            next: (data: any) => {
                if (!data?.result?.forcePasswordChange) {
                    setForcePasswordChangeFlag(false);
                    this.router.navigate(['/intro']);
                }
            },
            error: () => {}
        });
    }

    onSubmit() {
        if (this.changePasswordForm.invalid || this.submitting) {
            this.changePasswordForm.markAllAsTouched();
            return;
        }

        this.submitting = true;
        this.errorMessage = '';

        this.authApi.changePassword({
            oldpassword: this.changePasswordForm.controls['currentpassword'].value,
            newpassword: this.changePasswordForm.controls['password'].value
        }).subscribe({
            next: (response) => {
                this.submitting = false;
                if (response['result']) {
                    setForcePasswordChangeFlag(false);
                    this.successMessage = 'Contraseña actualizada. Redirigiendo...';
                    this.domainConfigComponent.load().then(() => {
                        this.sharedService.emitLogin('home');
                    });
                } else {
                    this.errorMessage = 'No se pudo cambiar la contraseña. Verifica tu contraseña actual.';
                }
            },
            error: () => {
                this.submitting = false;
                this.errorMessage = 'No se pudo cambiar la contraseña. Inténtalo de nuevo.';
            }
        });
    }
}
